import {Branch} from 'app/blocks/model/branch.model';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {ISiteVisitSkipReasons, SiteVisitSkipReasons} from 'app/blocks/model/site-visit-skip-reasons.model';

@Injectable({
    providedIn: 'root'
})
export class SiteVisitSkipReasonsService extends EntityCrudService<ISiteVisitSkipReasons> {
    constructor(http: HttpClient) {
        super(http, Resource.SITE_VISIT_SKIP_REASONS, (obj?) => new SiteVisitSkipReasons(obj));
    }
}
